import numeral from 'numeral';

export default function () {
    numeral.register("locale", "ms-my", {
        delimiters: {
            thousands: ".",
            decimal: ","
        },
        abbreviations: {
            thousand: "k",
            million: "m",
            billion: "b",
            trillion: "t"
        },
        currency: {
            symbol: "RM"
        }
    })
}